<div
  *ngIf="active"
  class="__realization-date">

  <span
    class="__realization-date-text"
    translate="ticketBase.realizationDateText">
  </span>

  <div>

    <vshcz-progress-item
      [active]="realizationDateConfirmLoading$ | async"
      [spinnerSize]="16"
      class="__realization-date-progress">
      <button
        mat-button
        (click)="onConfirmRealizationDate$.next()"
        type="button"
        class="__realization-date-button">
        <span translate="ticketBase.approve"></span>
      </button>
    </vshcz-progress-item>

    <vshcz-progress-item
      [active]="realizationDateRejectLoading$ | async"
      [spinnerSize]="16"
      class="__realization-date-progress">
      <button
        mat-button
        (click)="!!rejectRealizationDatePopRef.toggle()"
        [zpsSatPopoverAnchor]="rejectRealizationDatePopRef"
        type="button"
        class="__realization-date-button">
        <span translate="ticketBase.reject"></span>
      </button>
    </vshcz-progress-item>

  </div>

</div>

<!-- reject realization date pop -->
<zps-sat-popover
  #rejectRealizationDatePopRef
  hasBackdrop
  [autoFocus]="true"
  horizontalAlign="start"
  verticalAlign="below">
  <mat-card
    *ngIf="(ticketRealizationDateFormState$ | async) as formState"
    class="__pop mat-elevation-z5">

    <h4 class="__pop-title" translate="ticketBase.rejectRealizationDatePopTitle"></h4>

    <vshcz-form
      *ngIf="formState?.controls"
      #rejectFormRef
      (submit)="onRejectRealizationDate$.next()"
      [state]="formState"
      preventEnterSubmit>

      <vshcz-realization-date-reject-form
        [state]="formState">
      </vshcz-realization-date-reject-form>

      <vshcz-progress-error
        (retry)="rejectFormRef.triggerSubmit()"
        [errorCloseLabel]="'common.close' | translate"
        [errorRetryLabel]="'common.retry' | translate"
        [errorShowDetailsLabel]="'common.showMore' | translate"
        [errorHideDetailsLabel]="'common.hideMore' | translate"
        [errorKey]="rejectRealizationDateFailKey$ | async"
        [progressKey]="rejectRealizationDateRequestKey$ | async"
        denseButton>
        <button
          mat-raised-button
          color="warn"
          type="submit"
          class="__button"
          [class.is-disabled]="!formState.controls.messageText.value">
          <mat-icon>cancel</mat-icon>&nbsp;
          <span translate="ticketBase.reject"></span>
        </button>
      </vshcz-progress-error>

    </vshcz-form>

  </mat-card>
</zps-sat-popover>
